import { jsx as _jsx } from "react/jsx-runtime";
import React, { useImperativeHandle, useRef } from 'react';
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
import { userHasPermission } from "../../../../../swzutils/UserPermissionsUtil";
import ActiveStatusTag from "../../../components/ActiveStatusTag";
import dayjs from "dayjs";
import { loggedInUserSelector } from "../../../../../store/slice/auth";
import { CaretDownOutlined, CopyOutlined, EditOutlined, } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import { useAppSelector } from "../../../../../store";
const GeographicAreaTable = ({ loading, selectedRowId, onDataReceived, onRowSelectionChanged, onEditClicked, onCloneClicked }, exportedRef) => {
    const tableRef = useRef(null);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    useImperativeHandle(exportedRef, () => ({
        refresh: () => {
            tableRef.current?.fetch();
        },
        updateRecord: (record) => {
            tableRef.current?.updateRecord(record);
        },
        addRecord: (record) => {
            tableRef.current?.addRecord(record);
        },
    }));
    const columns = [{
            title: 'Delivery Area',
            dataIndex: 'title',
            width: '70%',
            filter: {
                type: 'text',
                placeholder: 'Search title',
                requestKey: 'titleLike'
            }
        }, {
            title: 'Priority',
            dataIndex: 'priority',
            width: '10%'
        }, {
            title: 'Active',
            dataIndex: 'enabled',
            filter: {
                type: 'enum',
                requestKey: 'enabled',
                enums: [{
                        text: 'Active',
                        value: true,
                    }, {
                        text: 'Inactive',
                        value: false,
                    }],
                filterMultiple: false,
            },
            width: '10%',
            render: (text, record) => {
                const isActive = !record.disabledAt || dayjs().isBefore(dayjs(record.disabledAt));
                return (_jsx(ActiveStatusTag, { active: isActive }));
            }
        }, {
            title: 'Actions',
            dataIndex: 'actions',
            width: '10%',
            condition: userHasPermission(loggedInUser, ['admin:geographicArea:update']),
            render: (text, record) => (_jsx(Dropdown, { destroyOnHidden: true, menu: {
                    items: [{
                            key: "editArea",
                            icon: _jsx(EditOutlined, {}),
                            label: "Edit",
                            onClick: () => onEditClicked(record)
                        }, {
                            key: "cloneArea",
                            icon: _jsx(CopyOutlined, {}),
                            label: "Clone",
                            onClick: () => onCloneClicked(record)
                        }]
                }, children: _jsx(Button, { children: _jsx(CaretDownOutlined, {}) }) }))
        }];
    return (_jsx(PaginatedFilterableTable, { tableKey: 'geographicalAreaTable', className: "filter-search-table", loading: loading, ref: tableRef, minWidthBeforeScrolling: 310, dataUri: "/admin/v1/geographic-areas", columns: columns, initialFilters: {
            "enabled": [true]
        }, refreshOnSelectedTenantChanged: true, onDataFetched: onDataReceived, rowClassName: (record /*, index*/) => {
            return record.id === selectedRowId ? "selected" : "";
        }, rowSelection: {
            type: 'radio',
            selectedRowKeys: selectedRowId ? [selectedRowId] : undefined,
            onChange: (selectedRowKeys, selectedRows) => {
                if (selectedRows.length) {
                    onRowSelectionChanged(selectedRows[0].id);
                }
                else {
                    onRowSelectionChanged(undefined);
                }
            }
        } }));
};
export default React.forwardRef(GeographicAreaTable);
